// src/redux/slices/referralTreeSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const fetchReferralTree = createAsyncThunk(
  "referralTree/fetchReferralTree",
  async ({ userId } = {}, { getState, rejectWithValue }) => {
    try {
      const { token } = getState().auth;

      if (!token) return rejectWithValue("No token found. Please login again.");

      const baseUrl =
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/RefferalTree/GetRefferalTree";

      const url = userId
        ? `${baseUrl}?userId=${encodeURIComponent(userId)}`
        : baseUrl; // if userId not passed => full tree

      const res = await fetch(url, {
        method: "GET",
        headers: {
          // If your API needs Bearer, use: Authorization: `Bearer ${token}`
          Authorization: token,
        },
      });

      if (!res.ok) {
        let msg = `Request failed (${res.status})`;
        try {
          const data = await res.json();
          msg = data?.message || data?.error || msg;
        } catch {}
        return rejectWithValue(msg);
      }

      const data = await res.json();
      return data;
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to load referral tree");
    }
  }
);

const referralTreeSlice = createSlice({
  name: "referralTree",
  initialState: {
    data: null,
    status: "idle", // idle | loading | succeeded | failed
    error: "",
  },
  reducers: {
    clearReferralTree: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReferralTree.pending, (state) => {
        state.status = "loading";
        state.error = "";
      })
      .addCase(fetchReferralTree.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetchReferralTree.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to load referral tree";
      });
  },
});

export const { clearReferralTree } = referralTreeSlice.actions;
export default referralTreeSlice.reducer;

// selectors
export const selectReferralTree = (s) => s.referralTree.data;
export const selectReferralTreeStatus = (s) => s.referralTree.status;
export const selectReferralTreeError = (s) => s.referralTree.error;
